import React from 'react';
import { map } from 'lodash';
import classNames from 'classnames';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { WIDGET_NAMES } from 'constants/entity-names';
import { PriorAuthDetailSummary } from 'ui/containers/PriorAuthDetailSummary';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { withNetworkState } from 'ui/hoc/withNetworkState';

// widget views
const WIDGET_VIEWS = {
    [ WIDGET_NAMES.PRIOR_AUTH_SUMMARY ]: PriorAuthDetailSummary
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { priorAuthDetail as PriorAuthDetail } from 'ui/views/widgets/priorAuthDetail';
 *
 * // render
 * <PriorAuthDetail propName='propValue'/>
 */
const _priorAuthDetail = ( props ) => {
    const { memberId, componentData, onNavActionClick } = props;
    const { navActions, widgets } = componentData;

    return (
        <div className='ui-prior-auth-detail'>

            <div className='ui-prior-auth-detail__action'>
                {
                    map( navActions, navAction => {

                        // get the action for navAction
                        const icondId = 'back' === navAction.name ? 'backArrow': null;

                        return (
                            <div className='ui-prior-auth-detail__action__navaction' key={ navAction.name }
                                onClick={ () => onNavActionClick( { type: 'headerAction', value: navAction } ) }
                            >
                                <Icon id={ icondId } />
                                <div className='ui-prior-auth-detail__action__navaction__label'>{ getLabel( navAction.title ) }</div>
                            </div>
                        );

                    } )
                }
            </div>

            {/* widget sequence view */}
            <div className='ui-prior-auth-detail__widgets'>
                {
                    map( widgets, widget => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        // widget class name
                        const widgetClassName = classNames( 'ui-prior-auth-detail__widgets__widget' );

                        return (
                            <div key={ widget.name } className={ widgetClassName }>
                                <WidgetView
                                    widget={ widget }
                                    memberId={ memberId }
                                />
                            </div>
                        );
                    } )
                }
                
            </div>
            
        </div>
    );
};

// set display name
_priorAuthDetail.displayName = 'priorAuthDetail';

// set default props
_priorAuthDetail.defaultProps = {};

// prop types
_priorAuthDetail.propTypes = {};


export const priorAuthDetail = withNetworkState( WidgetPreloader, _priorAuthDetail );
